/*
 * Click Imprenta - Barra de envío gratis (reemplaza assets/component-shipping-notice.js del tema "Local")
 * Mantiene los textos del tema (locales) y agrega una barra de progreso.
 * Funciona en el carrito lateral y en la página /cart, y se actualiza solo al cambiar cantidades.
 */
// Estilos de la barra (se inyectan una sola vez, no hace falta tocar el CSS del tema)
if ( !document.getElementById('shipping-bar-styles') ) {
  const style = document.createElement('style');
  style.id = 'shipping-bar-styles';
  style.textContent = `
    .shipping-bar { width: 100%; }
    .shipping-bar__text { font-size: 0.9em; line-height: 1.3; margin-bottom: 6px; }
    .shipping-bar__track { width: 100%; height: 8px; background: rgba(128,128,128,.35); border-radius: 999px; overflow: hidden; }
    .shipping-bar__fill { display: block; height: 100%; background: #ff7009; border-radius: 999px; transition: width .4s ease; }
    .shipping-bar--success .shipping-bar__fill { background: #1f9d55; }
    .shipping-bar--success .shipping-bar__text { font-weight: 600; }
        #site-cart-sidebar .cart-notice { background: #fff4ec !important; color: #1d1d1d !important; margin: 0 0 20px !important; padding: 14px 16px !important; border: 1px solid #ffd3b3; border-radius: 12px; }
    #site-cart-sidebar .cart-notice .shipping-bar__text { font-size: 14px; font-weight: 600; margin-bottom: 8px; }
    #site-cart-sidebar .cart-notice .shipping-bar__track { background: rgba(0,0,0,.1); height: 10px; }
    #site-cart-sidebar .cart-notice:has(.shipping-bar--success) { background: #e9f7ef !important; border-color: #b7e0c7; }
        #site-cart-sidebar .cart-notice { width: auto !important; box-sizing: border-box; }
  `;
  document.head.appendChild(style);
}

if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const rate = ( window.Shopify && Shopify.currency && Shopify.currency.rate ) ? Number(Shopify.currency.rate) : 1;
      const threshold = Math.round(freeShippingThreshold * rate);
      const freeShippingRemaining = cartTotal - threshold;
      const percent = threshold > 0 ? Math.max(0, Math.min(100, Math.round((cartTotal / threshold) * 100))) : 100;

      let shippingMessage = '';
      let shippingSuccess = false;

      if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));
      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      const bar = `
        <div class="shipping-bar ${shippingSuccess ? 'shipping-bar--success' : ''}">
          <div class="shipping-bar__text">${shippingMessage}</div>
          <div class="shipping-bar__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${percent}">
            <span class="shipping-bar__fill" style="width:${percent}%"></span>
          </div>
        </div>`;

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${bar}
          </div>`;
      } else {
        this.innerHTML = bar;
      }

    }

    _formatMoney(cents, format) {

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);

    }

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
